import { render, staticRenderFns } from "./LiveChatLinkPorts.vue?vue&type=template&id=7b00c7cc&scoped=true&"
import script from "./LiveChatLinkPorts.vue?vue&type=script&lang=js&"
export * from "./LiveChatLinkPorts.vue?vue&type=script&lang=js&"
import style0 from "./LiveChatLinkPorts.vue?vue&type=style&index=0&id=7b00c7cc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b00c7cc",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VIcon})
